import React from 'react';

import { BuildPath } from '../../../helpers/Paths';
import { UserUploadActionProgress, UserUploadHederError, UserUploadErrorReportItem } from '../../../models/ApiResponseModels/UserUploadActionProgressModel';

interface Step4Props {
    progressReport: UserUploadActionProgress
}

const Step4 = ({progressReport}:Step4Props) => {

    function getColumnName(index: number): string {
        return ['Username','Password','FirstName','LastName','DisplayName','JobRole','Department','ProfileEmailAddress','ProfilePhoneNumber','Groups'][index]
    }

    const Error = () => (
        <div className="upload-error">
            <p className="error-msg"> 
                <img alt='Error' src={`${BuildPath()}/images/userupload/error.svg`} />
                We found errors in your file. Please amend the file and restart the process. 
            </p>

            <div className="scrollable-error-container">
                <div className="scrollable-error">
                    <table>
                    <tbody>
                        {progressReport.ErrorReport.HeaderErrors.length >= 1 &&
                        <>
                            <tr>
                                <th colSpan={3}>Column headers do not match profile headers </th>  
                            </tr>
                            <tr>
                                <td><strong>Column</strong></td>  
                                <td><strong>Expected</strong></td>  
                                <td><strong>Actual</strong></td>  
                            </tr>
                            {progressReport.ErrorReport.HeaderErrors.map((error:UserUploadHederError, idx: number) => (
                                <tr key={`error-report-line-${idx+1}`}>
                                    <td>Column {error.ColumnNumber}</td>
                                    <td>{error.ExpectedText}</td>
                                    <td>{error.ActualText}</td>
                                </tr>
                            ))}
                        </>}

                        {progressReport.ErrorReport.RowErrors.length >= 1 && 
                        <>
                        <tr>
                            <th colSpan={3}>Validation Errors </th>  
                        </tr>
                        <tr>
                            <td><strong>Line</strong></td>  
                            <td><strong>Column</strong></td>  
                            <td><strong>Error</strong></td>  
                        </tr>
                        {progressReport.ErrorReport.RowErrors.map((error:UserUploadErrorReportItem, idx: number) => 
                            <tr key={`error-report-line-${idx+1}`}>
                                <td>{error.LineNumber}</td>
                                <td>{getColumnName(error.ColumnValidationResult.ColumnId)}</td>
                                <td>{error.ColumnValidationResult.ValidationErrors[0]}</td>
                            </tr>
                        )}
                    </>}
                       
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="error-links">
                <a target="_blank" href={"/api/UserImport/DownloadValidationErrorFile/" + progressReport.UserImportId}>Download Error Log </a>
            </div>
        </div>
    )
    

    const Processing = () => (
            <div className="upload-processing">
                <img alt='Processing' src={`${BuildPath()}/images/userupload/Rolling.svg`}/>
                <div>
                    <p> We’re now validating your CSV file. Don’t worry, we are just checking the file for errors.</p>
                    <p> You still need to review the pending changes before confirming the upload.</p>
                    <p>This could take a few minutes, You can wait for this process to finish or close this modal now and return to finalise your changes later.</p></div>
                
            </div> 
    )
    

    return (
        <>  
            <h3>Validating File</h3>
  
            {
            (progressReport && progressReport.Errors === true)
                ? <Error />
                : <Processing />
            }
        </>
    );
};

export default Step4;